<ng-container *ngIf="!loading; else loadingMask">
  <ng-dialog-header title="{{ title }}"></ng-dialog-header>
  <mat-dialog-content class="mat-dialog-content-storage">
    <form [formGroup]="form" class="justify-content-between">
      <div class="w-100 px-3">
        <p>
          {{ customer?.customerName }}
          -
          {{ userInfo ? userInfo.firstName + ' ' + userInfo.lastName : '' }}
        </p>
      </div>
      <div class="w-100 px-3 d-flex">
        <div class="d-inline">
          <h3>Type of Guarantee:</h3>
          <mat-radio-group (change)="storageStateChange($event)" aria-label="Select an option" class="" formControlName="guaranteeState">
            <mat-radio-button value="F" [disabled]="guarantee.guaranteeType === storageState.FULL_GUARANTEE && guarantee.guaranteed">Guarantee All Storage</mat-radio-button>
            <div class="d-inline px-3">
              <mat-radio-button value="P" [disabled]="!guarantee.lastFreeDateTime">Partial Storage</mat-radio-button>
              <mat-form-field class="date px-1" appearance="outline" color="accent">
                <mat-label>Search Date</mat-label>
                <mat-date-range-input [rangePicker]="picker" [min]="lastFreeDay" [max]="maxDate" [comparisonEnd]="endAtDate"
                                      [comparisonStart]="startAtDate" [disabled]="!guarantee.lastFreeDateTime && disablePicker">
                  <input matInput matStartDate readonly  aria-label="Start date" formControlName="startDate" placeholder="Start Date"
                         (dateChange)="pickerStartChanges($event.value)">
                  <input matEndDate matInput aria-label="End date" formControlName="endDate" placeholder="End Date"
                         (dateChange)="pickerEndChanges($event.value)" (dateInput)="pickerEndChanges($event.value)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker" class="float-left"></mat-datepicker-toggle>
                <mat-date-range-picker #picker [dateClass]="dateClass.bind(this)" [startAt]="lastFreeDay" (opened)="openedPicker()" (closed)="closedPicker()" [disabled]="disablePicker"></mat-date-range-picker>
                <mat-error *ngIf="endAtDate && maxDate">Guarantees in excess of 99 days are not allowed.</mat-error>
              </mat-form-field>
            </div>
            <mat-radio-button value="C" *ngIf="guarantee.guaranteed || cancelled" [disabled]="guarantee.guaranteeCancelled">Cancel Guarantee</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="d-inline px-3">
          <h3>Reference:</h3>
          <mat-form-field appearance="outline" style="width: 350px;">
            <mat-label>* Enter Reference #:</mat-label>
            <input matInput formControlName="reference" ngTrim [maxLength]="maxReferenceNumberLimit">
            <mat-hint align="end">{{ form.controls.reference.value ? form.controls.reference.value.length : 0}}/{{ maxReferenceNumberLimit }}</mat-hint>
            <mat-error [control]="form.controls.reference" ns-error></mat-error>
            <mat-error *ngIf="form.get('reference')?.hasError('eqMaxLength')">
              The limit of characters is {{ maxReferenceNumberLimit }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="px-3">
        <h3>Send Notifications to:</h3>
        <mat-form-field appearance="outline" color="warn" class="w-100">
          <mat-chip-list #chipMailList>
            <mat-chip
              *ngFor="let mail of emails; let i = index"
              [ngClass]="{'bg-white text-danger border border-danger': mail.invalid}"
              (removed)="removeEmail(i)">
              {{mail.email}}
              <button matChipRemove>
                <mat-icon fontIcon="fa-times" fontSet="fa" [ngClass]="{'text-danger': mail.invalid}" matSuffix>
                </mat-icon>
              </button>
            </mat-chip>
            <input
              placeholder="notifications@mycompany.com"
              formControlName="email"
              [matChipInputFor]="chipMailList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addEmail($event.value)">
          </mat-chip-list>
          <mat-hint align="end">{{ emails.length }}/10 emails</mat-hint>
          <mat-hint class="text-danger text-left mx-2" *ngIf="form.controls.email.dirty && form.controls.email.invalid"> {{form.controls.email.value}} is not valid email</mat-hint>
          <mat-hint class="text-danger text-left mx-2" *ngIf="form.controls.email.pristine && form.controls.email.errors?.invalidEmails"> One or more emails are not valid</mat-hint>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-card-actions *ngIf="((guarantee.guaranteed && guaranteeHistories.length > 0) || cancelled)" class="p-2 px-3 mx-0">
    <h3>Guarantee History:</h3>
    <ns-grid
      [name]="guaranteeHistoryGridConfig.gridName"
      [config]="guaranteeHistoryGridConfig.headerOptions"
      [gridOptions]="guaranteeHistoryGridConfig.options"
      [columns]="guaranteeHistoryGridConfig.columns"
      [data]="guaranteeHistories"
      (ready)="setGrid($event)"
      (dataRendered)="dataRenderedGrid()"
      [loading]="loading"
      class="grid-history"
    ></ns-grid>
  </mat-card-actions>
  <ng-dialog-footer>
    <div dialog-actions class="d-flex flex-fill align-items-center justify-content-between">
      <div>
         <span *ngIf="form.valid && !disableCancelling">
           <ng-container *ngIf="guarantee.guaranteed && !modified else guaranteeText">
             <ng-container *ngIf="form.get('guaranteeState')?.value === storageState.FULL_GUARANTEE">All charges are guaranteed</ng-container>
             <ng-container *ngIf="form.get('guaranteeState')?.value === storageState.PARTIAL">
               Charges for the first <strong>{{ guaranteeDays }} day{{ guaranteeDays > 1 ? 's' : '' }}</strong> through <strong>{{ endAtDate | nsDate:'MM/dd/yyyy' }}</strong> are guaranteed
             </ng-container>
           </ng-container>
           <ng-template #guaranteeText>
             By clicking submit, I
             <ng-container [ngSwitch]="form.get('guaranteeState')?.value">
               <ng-container *ngSwitchCase="storageState.CANCEL">agree to cancel storage guarantee</ng-container>
               <ng-container *ngSwitchCase="storageState.PARTIAL">
                 guarantee charges for the first
                 <strong>{{ guaranteeDays }} day{{ guaranteeDays > 1 ? 's' : '' }} </strong> through  <strong>{{ endAtDate | nsDate:'MM/dd/yyyy' }}</strong>
               </ng-container>
               <ng-container *ngSwitchDefault>guarantee <strong>all charges</strong></ng-container>
             </ng-container>
           </ng-template>
           for the unit: <strong>{{ this.guarantee.equipmentId }}</strong>
         </span>
      </div>
      <div>
        <button aria-label="Cancel" class="mx-2" color="warn" mat-dialog-close mat-stroked-button>Cancel</button>
        <button (click)="submit()"
                [disabled]="!form.valid || (guarantee.guaranteed && !modified) || (disableCancelling)"
                aria-label="Submit" color="accent" mat-flat-button>
          Submit
        </button>
      </div>
    </div>
  </ng-dialog-footer>
</ng-container>

<ng-template #loadingMask>
  <div class="loading-model">
    <ns-skeleton [type]="skeletonType"></ns-skeleton>
  </div>
</ng-template>
